import suppliers from './../../supplier/suppliers';
import {suppliersById} from './../../supplier/suppliers';
import appCONST from 'constants/app.constants';

export default function AdminHotelListService(
    $window,
    $http,
    l10nService
) {
    'ngInject';

        const hotelListEndpoint = '/management/hotels';
        const mergeHotelsEndpoint = '/management/hotels/merge';
        const HOTELS_PER_PAGE = 20;

        Object.assign(this, {
            getHotels,
            isHotelMerged,
            getSupplierLogo,
            getSupplierLogoIcon,
            getSupplierOrder,
            mergeHotels,
            hotelsHaveSameSupplier,
            showCantMergeMessage,
        });

        function mergeHotels(hotels) {
            const url = `${appCONST.apiUrl}${mergeHotelsEndpoint}`;
            return $http.post(url, {hotelIds: hotels})
                .then(({data: {hotel}}) => hotel);
        }

        function getHotels(params) {
            const url = appCONST.apiUrl + hotelListEndpoint;
            params.min = params.min || 0;
            params.max = params.max || HOTELS_PER_PAGE;

            return $http.get(url, {params})
                .then(({data}) => data);
        }

        function isHotelMerged(hotel) {
            return !!hotel.suppliers && hotel.suppliers.length > 1;
        }

        function getSupplierLogo(supplier) {
            return suppliersById[supplier]
                && suppliersById[supplier].logo
                || suppliers.unknown.logo;
        }

        function getSupplierLogoIcon(supplier) {
            return suppliersById[supplier]
                && suppliersById[supplier].logoIcon
                || suppliers.unknown.logoIcon;
        }

        function getSupplierOrder(supplier) {
            return suppliersById[supplier]
                && suppliersById[supplier].priority;
        }

        function hotelsHaveSameSupplier(hotelProfiles, hotelsToMerge) {
            const flatten = hotelProfiles
                .filter(({id}) => hotelsToMerge.includes(id))
                .map((hotel) => hotel.suppliers)
                .reduce((acc, value) => acc.concat(value));

            return Array.from(new Set(flatten)).length !== flatten.length;
        }

        function showCantMergeMessage() {
            const message = 'You can merge Hotel Profiles for the same Hotel only. Please check the selected items.';
            const translation = l10nService.localize(message);
            $window.alert(translation);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-list-service.js